export const QUESTIONS_ANSWERS = [
  {
    id: 1,
    queston: 'Как рассчитывается рейтинг?',
    answer:
      'Рейтинг рассчитывается на основе количества показов объектов недвижимости потенциальным покупателям и арендаторам недвижимости на Циан. Показатель характеризует, сколько раз объявления вашего агентства недвижимости увидели потенциальные клиенты. С сентября 2023 года показами на карте считаются только клики на объект на карте.',
  },
  {
    id: 2,
    queston: 'Как часто обновляется рейтинг?',
    answer: 'Рейтинг обновляется ежемесячно на основе данных за прошедший календарный месяц.',
  },
  {
    id: 3,
    queston: 'Как можно использовать рейтинг на сторонних ресурсах?',
    answer: 'Публикация рейтинга на сторонних ресурсах возможна только с указанием ссылки на источник cian.ru',
  },
  {
    id: 4,
    queston: 'Как рассчитывается охват компании?',
    answer: 'Охват компании складывается из показов объявлений всех её аккаунтов.',
  },
];
